import { useGenerarCertificadoMutation } from "../../../services/docs";
import { Spinner } from "../../../components/Spinner";
import Button from "../../../components/ui/Button";
import { toastr } from "react-redux-toastr";
import { Label } from "../../../components/ui/Label";
import { Input } from "../../../components/ui/Input";
import { useForm } from "../../../hooks/useForm";
import { Icon } from "../../../components/ui/Icon";

export const ImprimirPDFScreen = () => {
  const [cargaAction, { isLoading: cargando, data }] =
    useGenerarCertificadoMutation();
  const { formulario, handleInputChange, handleChange } = useForm({
    fc_certificado: "",
  });

  const guardarArchivo = async () => {
    console.log(formulario);
    const resp = await cargaAction({
      ...formulario,
    })
      .unwrap()
      .catch((err) => {
        const errorData = err.data || err;
        console.log(errorData.message);
        const mensajes = errorData.message || "Ocurrió un error inesperado";
        const textoAMostrar = Array.isArray(mensajes)
          ? mensajes.join("<br>") // Separa los errores con un salto de línea en el Toastr
          : mensajes;
        console.log(textoAMostrar);
        toastr.error(textoAMostrar);
      });
    if (resp) {
      toastr.info("PDF Generado");
    }
  };
  return (
    <div className="card">
      <div className="space-y-6">
        <div className="mb-3 mt-5 w-full">
          <div className="flex items-center">
            <div className="w-3/4">
              <h6>Imprimir Certificado</h6>
            </div>
            <div className="mb-1 w-1/4"></div>
          </div>
          <hr />
        </div>
        <div className="my-2">
          <div className="flex flex-col px-6 py-2">
            <Label className="my-2" htmlFor="fc_valor">
              Certificado:
            </Label>
            <Input
              type="text"
              name="fc_certificado"
              onChange={handleInputChange}
            />
          </div>
          {!cargando && (
            <div className="flex flex-col px-6 py-2">
              <Button onClick={guardarArchivo}>Buscar</Button>
            </div>
          )}
          {cargando && <Spinner />}
        </div>

        {!cargando && data && data.archivo && (
          <div className="flex w-full flex-col justify-center justify-items-center px-6 py-2 text-center">
            <a
              href={data.archivo.archivo}
              target="_blank"
              className="flex w-full justify-center text-primary"
            >
              <Icon variante={"descarga"} />
            </a>
          </div>
        )}
      </div>
    </div>
  );
};
